import { useEffect } from "react";
import { isBrowser } from "browser-or-node";
export const useOnWindowFocused = (cb, deps) => {
    useEffect(() => {
        if (isBrowser) {
            window.addEventListener("focus", cb);
            return () => {
                window.removeEventListener("focus", cb);
            };
        }
    }, deps);
};
